import { authAxios, adminAxios } from '../helpers/api';

export const postLogIn = ({ email, password }) =>
  authAxios.post('auth/login', { email, password });

export const postLogOut = () => authAxios.post('auth/logout');

export const getProfileDetailAdmin = () => adminAxios.get('auth/detail');
